import { render, staticRenderFns } from "./HeaderLandingPageThankYou.vue?vue&type=template&id=1bb72136&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/opt/build/repo/components/Header.vue').default})
